import React from "react";
import { ReactComponent as DashboardIcon } from "../assets/images/icons/DashboardIcon.svg";
import { ReactComponent as CondominiumsIcon } from "../assets/images/icons/CondominiumsIcon.svg";
import { ReactComponent as ResidentsIcon } from "../assets/images/icons/ResidentsIcon.svg";
import { ReactComponent as LockersIcon } from "../assets/images/icons/LockerIcon.svg";
import { ReactComponent as GuestAccessIcon } from "../assets/images/icons/GuestAccessIcon.svg";
import { ReactComponent as DocumentsIcon } from "../assets/images/icons/DocumentsIcon.svg";
import { ReactComponent as ReportsIcon } from "../assets/images/icons/ReportsIcon.svg";
import { ReactComponent as EnergyIcon } from "../assets/images/icons/EnergyIcon.svg";
import { ReactComponent as PollsIcon } from "../assets/images/icons/PollsIcon.svg";
const Navdata = () => {
  // const [isRevenue, setIsRevenue] = useState(false);

  const menuItems: any = [
    {
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "navigation.dashboard",
      icon: <DashboardIcon height={30} />,
      link: "/dashboard",
      disabled: true,
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "condominiums",
      label: "navigation.condominiums",
      icon: <CondominiumsIcon height={30} width={30} />,
      link: "/condominiums",
      disabled: false,
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "residents",
      label: "navigation.residents",
      icon: <ResidentsIcon height={30} />,
      link: "/residents",
      disabled: true,
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "lockers",
      label: "navigation.lockers",
      icon: <LockersIcon height={30} />,
      link: "/lockers",
      disabled: true,
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "guestAccess",
      label: "navigation.guestAccess",
      icon: <GuestAccessIcon height={30} width={30} />,
      link: "/guest-access",
      subItems: [
        {
          id: "guestAccessRequests",
          label: "navigation.accessRequests",
          link: "/access-requests",
          disabled: false,
          click: function (e: any) {
            e.preventDefault();
          },
        },
        {
          id: "pastGuestAccess",
          label: "navigation.pastGuestAccess",
          link: "/past-guest-access",
          disabled: false,
          click: function (e: any) {
            e.preventDefault();
          },
        },
      ],
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "documents",
      label: "navigation.documents",
      icon: <DocumentsIcon height={30} width={30} />,
      link: "/documents",
      disabled: true,
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "polls",
      label: "navigation.polls",
      icon: <PollsIcon height={30} width={30} />,
      link: "/polls",
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "reports",
      label: "navigation.reports",
      icon: <ReportsIcon height={30} width={30} />,
      link: "/reports",
      click: function (e: any) {
        e.preventDefault();
      },
    },
    {
      id: "energy",
      label: "navigation.energy",
      icon: <EnergyIcon height={30} width={30} />,
      link: "/energy",
      disabled: true,
      click: function (e: any) {
        e.preventDefault();
      },
    },

    // {
    //   id: "builder",
    //   label: "Builder",
    //   icon: "mdi mdi-account-hard-hat",
    //   link: "/builder",
    //   click: function (e: any) {
    //     e.preventDefault();
    //   },
    // },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
